// import { createHashHistory } from 'history';
// export default createHashHistory();

import { navigate } from 'gatsby'

const push = (url: string) => navigate(url)

export default {
  push,
}